import script from "./ParticipantCameraTest.vue?vue&type=script&setup=true&lang=js"
export * from "./ParticipantCameraTest.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__